import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, Field, change } from 'redux-form';
import MediaQuery from 'react-responsive';

import MenuItem from 'material-ui/MenuItem';
import { TextField, SelectField } from 'redux-form-material-ui';

import { CSSTransitionGroup } from 'react-transition-group';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import PropertyUnitSelector from 'components/shared/PropertyUnitSelector';
import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import Header from 'components/shared/Header';

import { DateTimePickerRedux } from 'helpers/reduxFormMaterialUiNext/DateTimePicker';
import { extractTenants } from 'helpers/tenantExtraction';
import { required } from 'helpers/Validator';
import { deepDiver } from 'helpers/utilities';

import {
  getProperties,
  getUnits,
  getActiveLeaseOfUnit,
  clearActiveLeaseOfUnit,
  showUnits,
} from 'actions/landlordPropertiesActions';

class AddLogForm extends Component {
  constructor(props) {
    super(props);
    this.state = { showTenant: false, showDetails: false };
  }

  fetchActiveLeaseOfUnit = unit => {
    this.props.getActiveLeaseOfUnit(unit).then(result => {
      if (!result.value) {
        this.setState({ showDetails: true });
      }
      this.props.changeFieldValue('unit_active_lease', result.value);
    });
  };

  onPropertyChange = propertyId => {
    this.setState({ showTenant: false, showDetails: false });
    this.props.getUnits(propertyId.value, { for_multiselect: true }).then(response => {
      if (!deepDiver(response, 'value.data.0.label')) {
        this.onUnitChange(deepDiver(response, 'value.data.0'));
      }
    });
  };

  onUnitChange = event => {
    this.clearSelections();

    if (!event.value) {
      this.setState({ showTenant: false });
      return;
    }
    this.clearSelections();
    this.fetchActiveLeaseOfUnit(event.value);
    this.setState({ showTenant: true });
  };

  clearSelections = () => {
    this.props.clearActiveLeaseOfUnit();
    this.props.changeFieldValue('tenant', null);
  };

  render() {
    return (
      <form handleSubmit={this.onSubmit} autoComplete="off">
        <div className="row">
          <div>
            <Header name="LOCATION DETAILS" />
            <div className="row" style={{ marginBottom: '20px' }}>
              <PropertyUnitSelector
                properties={this.props.properties}
                units={this.props.units}
                onPropertyChange={this.onPropertyChange}
                propertyInnerDivStyle={{
                  width: '100%',
                  fontSize: '14px',
                  fontWeight: '100 !important',
                }}
                propertyMenuStyle={{ minWidth: '250px', fontSize: '14px' }}
                propertyStyle={{ textAlign: 'left', fontSize: '14px' }}
                unitMenuStyle={{ fontSize: '14px' }}
                unitStyle={{ textAlign: 'left', fontSize: '14px' }}
                onUnitChange={this.onUnitChange}
                allowNone
              />

              <CSSTransitionGroup
                transitionName="show_dropdown_28px"
                transitionEnterTimeout={500}
                transitionLeaveTimeout={500}
              >
                {this._renderTenantsDropdown()}
              </CSSTransitionGroup>
            </div>
          </div>

          <MediaQuery query="(min-device-width: 750px)">
            <CSSTransitionGroup
              transitionName="show_logs_form"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}
            >
              {this._renderDetails()}
            </CSSTransitionGroup>
          </MediaQuery>

          <MediaQuery query="(max-device-width: 750px)">
            <CSSTransitionGroup
              transitionName="show_logs_form_mobile"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}
            >
              {this._renderDetails()}
            </CSSTransitionGroup>
          </MediaQuery>
        </div>
      </form>
    );
  }

  _renderDetails = () => {
    if (!this.state.showDetails) return;

    return (
      <div className="row">
        <Header name="LOG DETAILS" />
        <div className="row" style={{ marginTop: '10px' }}>
          <div className="col-xs-6">
            <Field
              name="title"
              component={TextField}
              validate={[required]}
              floatingLabelText="Title"
              fullWidth
              style={{ marginTop: '-10px', fontSize: '14px' }}
            />
          </div>
          <div className="col-sm-6">
            <Field
              name="log_type"
              component={SelectField}
              floatingLabelText="Log Type"
              style={{
                marginTop: '-15px',
                fontSize: '14px',
                width: '100%',
                height: '77px',
              }}
              validate={[required]}
            >
              <MenuItem value="shift_log" primaryText="Shift Log" />
              <MenuItem value="incident" primaryText="Incident" />
              <MenuItem value="tenant_request" primaryText="Resident Request" />
              <MenuItem value="complaint" primaryText="Complaint" />
            </Field>
          </div>
          <div className="row">
            <div className="col-sm-6" style={{ marginTop: '15px' }}>
              <Field
                name="log_date"
                component={DateTimePickerRedux}
                label="Log Time"
                fullWidth
                validate={[required]}
                style={{ marginTop: '-10px', fontSize: '14px' }}
              />
            </div>
          </div>

          <div className="col-xs-12">
            <Field
              name="details"
              component={TextField}
              validate={[required]}
              floatingLabelText="Details"
              multiLine
              fullWidth
              rows={3}
              style={{ marginTop: '-10px', fontSize: '14px' }}
            />
          </div>
        </div>
      </div>
    );
  };

  _renderTenantsDropdown = () => {
    if (!this.state.showTenant) return;
    const tenants = extractTenants(this.props.unitActiveLease);
    if (!tenants.length) return;

    return (
      <div className="col-sm-12" style={{ margin: '30px 0 15px' }}>
        <Field
          name="tenant"
          data={tenants || []}
          onChange={() => this.setState({ showDetails: true })}
          component={MultiSelectExtended}
          hintText={
            <span>
              <TenantResidentVerbiageHelper capitalize />s
            </span>
          }
          innerDivStyle={{
            width: '100%',
            fontSize: '15px',
            fontWeight: '100 !important',
          }}
          menuStyle={{ minWidth: '250px', fontSize: '14px' }}
          style={{ fontSize: '14px' }}
          fullWidth
          validate={[required]}
          disabled={!this.props.unitActiveLease}
        />
      </div>
    );
  };
}

export default compose(
  connect(
    state => ({
      properties: state.landlordProperties.properties,
      units: state.landlordProperties.units,
      unitActiveLease: state.landlordProperties.unitActiveLease,
    }),
    {
      getActiveLeaseOfUnit,
      getUnits,
      getProperties,
      clearActiveLeaseOfUnit,
      showUnits,
      changeFieldValue: (field, value) => change('add_log_form', field, value),
    }
  ),
  reduxForm({
    form: 'add_log_form',
    destroyOnUnmount: true,
  })
)(AddLogForm);
